import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({ selector: '[dataTableCell]', standalone: true })
export class DataTableCellDirective {

    public readonly $column = input.required<string>({ alias: 'dataTableCell' });
    public readonly template = inject(TemplateRef);
}
